import React, { Component } from "react";
import { db } from "./services/firebase";
import Cookies from 'universal-cookie';
import iconBack from "./images/icon-left-arrow.png";
import Locale from "./components/Locale";

export default class Name extends Component{
  constructor(props){
    super(props);
    this.cookies = new Cookies();
    this.state = {
      name: '',
      redirectChat: false,
      error: false,
    }
    this.handleName = this.handleName.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount(){
   
  }

  render() {
    if(this.state.redirectChat === true){
      window.location.reload(false);
    }
    return (
      <div>
        <header>
            <span className="back"><a href="/"><img src={iconBack} alt="<" width="20" height="20" /></a></span>
            <span className="title">{Locale.admin}</span>
        </header>

        <div id="name">
            <h2>{Locale.whatsyourname}</h2>
            <input type="text" value={this.state.name} onChange={this.handleName} />
            <button onClick={this.handleSubmit}>
                Ok
            </button>
            <div className="error">{(this.state.error)?this.state.error:''}</div>
        </div>
      </div>
    );
  }

  handleSubmit(){
    const timestamp = new Date().getTime();
    const db_Chats = db.ref('chats');
    const db_Messages = db.ref('messages');
    const name = this.state.name;

    if(name === ''){
      this.setState({error: Locale.error.name});
    }else{
      db_Chats.push({
          name,
          timestamp,
          unread: false
      })
      .then((snap) => {
          const supportID = snap.key;
          const expire = timestamp + (60 * 60 * 24 * 1000 * 3);
          const expireDate = new Date(expire);
          this.cookies.set('supportID', snap.key, { expires: expireDate });

          db_Messages.child(supportID).push({
              content: Locale.welcomeMessage.replace('###name###', name),
              timestamp,
              from: 'admin',
              viewed: false
          })
          .then(() => {
              this.setState({redirectChat: true});
          })

      });
    }
  }

  handleName(event){
    this.setState({name: event.target.value});
  }

}
